module.exports = __webpack_public_path__ + "img/rest.01ccfc5a.svg";